import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentService } from '../../services/component.service';
import { NicaMenuService } from '../../services/nica-menu.service';

@Component({
  selector: 'app-nica-widget',
  templateUrl: './nica-widget.component.html',
  styleUrls: ['./nica-widget.component.css']
})
export class NicaWidgetComponent implements OnInit {
  widget:any;
  constructor(private menuService:NicaMenuService,private router: Router, private componentService: ComponentService ) { }

  ngOnInit() {
    this.menuService.menuPref.subscribe(data=>{
     
      this.initFavMenu(data)
    });

  }
  initFavMenu(itm){
   
    let res = this.chooseItems(itm);
    this.widget= res

   
  }

  chooseItems(itm,arrayWidget=[],k=0){
    
    
    for(let i = 0 ; i < itm.length; i++){
      
      if(itm[i].items){
        
        
        if(typeof itm[i].key !== 'undefined'){
          
          arrayWidget.push({
            text:itm[i].key,
            items:[]
          })
        }

        this.chooseItems(itm[i].items,arrayWidget,i)
       
      }else{
        
        if(itm[i].fav){
          const index = arrayWidget[k].items.findIndex(object => object.id === itm[i].id);
          //console.log(index)
          if (index === -1) {
            arrayWidget[k].items.push(itm[i]);
          }  

          itm[i].tooltip=false;
          
          

        }
      }  
      
    } 
    
    
    return arrayWidget.filter(res=>res.items.length>0)
  } 

  itemAction(ev){
   
    const itemData = ev.itemData;

    /*let path = itemData.text.toLowerCase().replace(/[^a-zA-Z ]/g, '');
    path =  path.replace(/\s/g, '-');

    const pathDef = 'main/'+path
    
    this.router.navigate([pathDef])
    .then(data => {
      
      console.log('Route exists, redirection is done',data);
    })
    .catch(e => {
      this.router.navigate(['main/dashboard'])
    });*/

    let path = itemData.text;
      let component = itemData.controller

      let tabsJson =[
        {
          id:itemData.id,
          title: path,
          icon: 'user',
          key:'dash',
          component:component,
          

        }
      ];
      this.componentService.addNewTab('dashboard', tabsJson);

  }

  setVisible(itm){
    
    if(!itm.tooltip){
      itm.tooltip = true
    }else{
      itm.tooltip = false;
    }
    
  }

  hideRightList(){

    document.getElementById('nica-sidebar-right').classList.toggle('hide');
    document.getElementById('btnActionRight').classList.toggle('right-zero');

   // document.getElementById('content-center').classList.add('col-12 ');
    document.getElementById('content-center').classList.toggle('col-10');
    document.getElementById('content-center').classList.toggle('col-lg-10');
    document.getElementById('content-center').classList.toggle('col-lg-12');
  }
}
